<template>
  <div
    v-if="show"
    class="bg-orange-100/80 z-50 ring-hairline py-3"
  >
    <div class="container flex flex-row items-center justify-between gap-3 text-orange-800 text-sm md:text-base">
      <span>
        {{ duzen('Du hast', 'Sie haben') }} noch kein Passwort gesetzt.
        <RouterLink :to="{ name: Finanzmanager.ACCOUNT }">
          <span class="font-semibold text-orange-800 underline underline-offset-2">Jetzt Passwort festlegen</span>
        </RouterLink>
      </span>
      <ElTooltip content="Nachricht ausblenden" placement="bottom">
        <button
          type="button"
          class="cursor-pointer w-8 text-center rounded-full hover:bg-orange-300 hover:text-orange-800"
          @click="close"
        >
          <FaIcon name="times" />
        </button>
      </ElTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { useBaseDataStore } from '@/user/store/baseDataStore';
import { getLocalStorage, setLocalStorage } from '@/application/utils/localStorage';
import { Finanzmanager } from '@/application/router/types/types';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { useRoute } from 'vue-router';
import { ElTooltip } from 'element-plus';

const TTL = 60 * 60 * 24; // 1 day
const LS_KEY = 'password-banner';

const { hasPasswortSet, duzen } = useBaseDataStore();
const route = useRoute();

const show = ref(!hasPasswortSet && getLocalStorage(LS_KEY) === null && route.meta.public !== true);

const close = () => {
  show.value = false;
  setLocalStorage(LS_KEY, false, TTL);
};
</script>
